import type { AdditionalOption } from '../model/interfaces'

import { OnboardingTimeframe, ReferralSource, TeachingExperienceYears } from '../model/enums'

export const yesNoOptions: AdditionalOption[]  = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
]

export const onboardingTimeframe: AdditionalOption<OnboardingTimeframe>[] = [
  { label: 'I’m ready to complete the onboarding course within 2 days', value: OnboardingTimeframe.Within2Days },
  { label: 'I’m ready to complete the onboarding course within 5 days', value: OnboardingTimeframe.Within5Days },
  { label: 'I’m ready to complete the onboarding course within a week', value: OnboardingTimeframe.WithinWeek },
]

export const referralSourceOptions: AdditionalOption<ReferralSource>[] = [
  { label: 'Facebook', value: ReferralSource.Facebook },
  { label: 'Instagram', value: ReferralSource.Instagram },
  { label: 'TikTok', value: ReferralSource.TikTok },
  { label: 'LinkedIn', value: ReferralSource.LinkedIn },
  { label: 'YouTube', value: ReferralSource.YouTube },
  { label: 'Google Search', value: ReferralSource.GoogleSearch },
  { label: 'Recommendation', value: ReferralSource.Recommendation },
  { label: 'Job Board', value: ReferralSource.JobBoard },
]

export const teachingExperienceOption: AdditionalOption<TeachingExperienceYears>[]  = [
  { label: 'No experience', value: TeachingExperienceYears.NoExperience },
  { label: 'Less than 1 year', value: TeachingExperienceYears.LessThan1Year },
  { label: '1 - 3 years', value: TeachingExperienceYears.From1To3Years },
  { label: 'More than 3 years', value: TeachingExperienceYears.MoreThan3Years },
]